import React from 'react';
import { ArrowRight, Rocket } from 'lucide-react';
import { KPI_ICONS, TEMPLATE_COLORS } from './constants';
import { TEMPLATE_IMPACT_STAGE, STAGE_BADGE_LABELS, recoveryPotential } from '../../lib/solutionStages';

export const TemplateCard = ({ template, onSelect, loading, constraintStage }) => {
  const IconComponent = KPI_ICONS[template.icon] || Rocket;
  const colors = TEMPLATE_COLORS[template.color] || TEMPLATE_COLORS.blue;
  const stage = TEMPLATE_IMPACT_STAGE[template.id];
  const isRecommended = !!stage && stage === constraintStage;
  const potential = recoveryPotential(template);
  const potentialCls = potential === 'High'
    ? 'bg-emerald-50 text-emerald-700 border-emerald-200'
    : 'bg-sky-50 text-sky-700 border-sky-200';

  return (
    <div
      data-testid={`template-card-${template.id}`}
      onClick={() => !loading && onSelect(template)}
      className={`relative p-4 rounded-xl border-2 cursor-pointer transition-all duration-200 ${colors.border} ${colors.hover} ${colors.bg} hover:shadow-md group ${isRecommended ? 'ring-2 ring-orange-300' : ''}`}
    >
      {isRecommended && (
        <span
          className="absolute -top-2.5 left-3 text-[9px] font-bold uppercase tracking-wider bg-orange-500 text-white rounded-full px-2 py-0.5 shadow-sm"
          data-testid={`template-recommended-${template.id}`}
        >
          Recommended for your constraint
        </span>
      )}
      <div className="flex items-start gap-3">
        <div className={`p-2.5 rounded-lg ${colors.icon} group-hover:scale-110 transition-transform`}>
          <IconComponent size={24} />
        </div>
        <div className="flex-1 min-w-0">
          <h3 className="font-semibold text-gray-900 group-hover:text-blue-600 transition-colors">
            {template.name}
          </h3>
          <p className="text-sm text-gray-600 mt-1 line-clamp-2">{template.description}</p>
          <div className="flex flex-wrap gap-1.5 mt-3">
            {template.expected_outcomes?.slice(0, 2).map((outcome, idx) => (
              <span key={`outcome-${outcome.slice(0, 20)}-${idx}`} className="text-xs px-2 py-0.5 bg-white/70 rounded-full text-gray-600">
                {outcome.split(' ').slice(0, 4).join(' ')}...
              </span>
            ))}
          </div>
          <div className="flex flex-wrap items-center gap-1.5 mt-2.5">
            {stage && (
              <span
                className="text-[10px] font-semibold px-2 py-0.5 rounded-full bg-white border border-slate-200 text-slate-500"
                data-testid={`template-stage-${template.id}`}
              >
                Primary Impact Stage · <span className="font-bold text-slate-800">{STAGE_BADGE_LABELS[stage]}</span>
              </span>
            )}
            <span
              className={`text-[10px] font-semibold px-2 py-0.5 rounded-full border ${potentialCls}`}
              data-testid={`template-recovery-${template.id}`}
            >
              {potential} Recovery Potential
            </span>
          </div>
        </div>
        <ArrowRight className="text-gray-400 group-hover:text-blue-600 group-hover:translate-x-1 transition-all flex-shrink-0" size={20} />
      </div>
    </div>
  );
};
